export function setContactsWrong(state, contacts) {
    state.contacts_find_wrong = contacts;
}

export function setContactsCorrect(state, contacts) {
    state.contacts_find_correct = contacts;
}

export function setQueryWrong(state, query) {
    state.params_contact_wrong.query = query;
}

export function setQueryCorrect(state, query) {
    state.params_contact_correct.query = query;
}

export function setInconsistentContacts(state, contacts) {
    state.inconsistentContacts = contacts;
}

export function resetUnifyParam(state) {
    state.unifyParam = {
        wrong_contact_id: null,
        correct_contact_id: null,
        wrong_warehouse_id: null,
        correct_warehouse_id: null
    };
    state.warehouses_wrong = [];
    state.warehouses_correct = [];
}

export function setWrongContactFromRow(state, row) {
    state.unifyParam.wrong_contact_id = row.id;

    const alreadyLoaded = state.contacts_find_wrong.some(contact => contact.id === row.id);

    if (!alreadyLoaded) {
        state.contacts_find_wrong = [
            { id: row.id, identification: row.identificacion, name: row.tercero, surname: '' },
            ...state.contacts_find_wrong
        ];
    }
}

export function setWarehousesWrong(state, warehouses) {
    state.warehouses_wrong = warehouses;
}

export function setWarehousesCorrect(state, warehouses) {
    state.warehouses_correct = warehouses;
}

export function resetWrongWarehouse(state) {
    state.unifyParam.wrong_warehouse_id = null;
    state.warehouses_wrong = [];
}

export function resetCorrectWarehouse(state) {
    state.unifyParam.correct_warehouse_id = null;
    state.warehouses_correct = [];
}



// WEBPACK FOOTER //
// ./src/modules/unify-contacts/mutations.js